import "./Achiever.css";

export default function Achiever({ name, marks, image }) {
  return (
    <div className="star-glow-card">
      <div className="card-glow-border">
        <div className="star-photo">
          <img src={image} alt={name} />
          <div className="badge">🏆</div>
        </div>
        <div className="star-info">
          <h3>{name}</h3>
          <p>Score: <span>{marks}</span></p>
          <div className="congrats-animation">🎉 Congratulations! 🎉</div>
        </div>
      </div>
    </div>
  );
}
